import { createAsyncThunk } from "@reduxjs/toolkit";
import { ftpPublishAPIs } from "services/api/publisher/ftpPublishAPIs";
import { handleApiError } from "utils/errorHandler";

export const ftpPublish = createAsyncThunk("ftpPublish/ftpPublish", async (payload) => {
  try {
    const response = await ftpPublishAPIs.ftpPublish(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    const errorMessage = error?.response?.data?.error?.message;
    const message = Array.isArray(errorMessage) ? errorMessage.join(", ") : errorMessage;
    const errorObj = { ...(error?.response?.data?.error || error), message };
    throw errorObj;
  }
});

export const getFtpList = createAsyncThunk("ftpPublish/getFtpList", async (payload) => {
  try {
    const response = await ftpPublishAPIs.getFtpList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createFtpCredentials = createAsyncThunk("ftpPublish/createFtpCredentials", async (payload) => {
  try {
    const response = await ftpPublishAPIs.createFtpCredentials(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw handleApiError(error);
  }
});

export const updateFtpCredentials = createAsyncThunk("ftpPublish/updateFtpCredentials", async (payload) => {
  try {
    const response = await ftpPublishAPIs.updateFtpCredentials(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw handleApiError(error);
  }
});

export const deleteFtpCredentials = createAsyncThunk("ftpPublish/deleteFtpCredentials", async (payload) => {
  try {
    const response = await ftpPublishAPIs.deleteFtpCredentials(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw handleApiError(error);
  }
});
